const messages = {
  title: "Bonus multiplikator",
  bandBonusTitle: "Bonus po gumi s multiplikatorom",
  amountLabel: "Min. broj guma (*)",
  label: "Bonus multiplikator",
  desc: "Broj Bridgestone i Firestone guma. Nema bonusa u eurima na Firestone gume.",
  goals: {
    loyal: "Lojalan",
    bronze: "Bronca",
    silver: "Srebro",
    gold: "Zlato",
    platinum: "Platina",
  },
  andMore: "i više",
  chooseTarget: "Odaberi",
  selectTarget: "Odaberite svoj godišnji cilj za {year}:",
  multiplication: "Bonus se množi s <b>{factor}</b>",
  minTyres: "<b>Minimum:</b> {tyre} guma",
};

export default {
  messages,
};
